import Dexie from "dexie";

interface MunicipiosLista {
  idCache: number;
  municipioDestinoId: number;
  municipioNome: string;
}

interface CadastroViagem {
  idCache?: number;
  id: number;
  latitute: number;
  longitude: number;
  municipioOrigemId: number;
  municipioDestinoId: number;
  municipioOrigemNome: string;
  municipioDestinoNome: string;
  dataInicio: string;
  passageiroList: [];
  status: string;
  dataFim: string;
  viagemOrigemId: number;
  sentido: string;
  idViagemOrigem: number;
  idVeiculo?: number;

}

interface Viagens {
  idCache?: number;
  id: number;
  latitute: number;
  longitude: number;
  municipioOrigemId: number;
  municipioDestinoId: number;
  municipioOrigemNome: string;
  municipioDestinoNome: string;
  dataInicio: string;
  dataFim: string;
  passageiroList: [];
  status: string;
  viagemOrigemId: number;
  sentido: string;
}
class DatabaseMunicipios extends Dexie {
  public municipiosLista: Dexie.Table<MunicipiosLista, String>;

  constructor() {
    super("lista-municipios");
    this.version(1).stores({
      municipiosLista: "++idCache, municipioDestinoId, municipioNome",
    });
  }
}

class DatabaseViagens extends Dexie {
  public cadastroViagem: Dexie.Table<CadastroViagem, string>;

  constructor() {
    super("cadastro-viagem");
    this.version(1).stores({
      cadastroViagem:
        "++idCache, id, latitude, longitude, idOrigem, idDestino, passageiroList, status, dataFim, viagemOrigemId, idVeiculo",
    });
  }
}

class DatabaseViagensOffline extends Dexie {
  public viagens: Dexie.Table<Viagens, string>;

  constructor() {
    super("viagens");
    this.version(1).stores({
      viagens:
        "++idCache, id, latitude, longitude, idOrigem, idDestino, passageiroList, status, dataFim, viagemOrigemId",
    });
  }
}

const municipiosDB = new DatabaseMunicipios();
const cadastroViagemDB = new DatabaseViagens();
const viagensOfflineDB = new DatabaseViagensOffline();

export { municipiosDB, cadastroViagemDB, viagensOfflineDB };
